import { BlockchainNetwork } from "../constants.js"
import { EVM_V2_NETWORKS } from "../blockchains/evmV2Networks.js"

type BlockchainPrefixes = { [K in BlockchainNetwork]?: string }
// coinpath.state keeps EVM addresses and hashes without the 0x
export const blockchainPrefixes: BlockchainPrefixes = Object.fromEntries(
    EVM_V2_NETWORKS.map((network) => [network.blockchain, '0x'])
)

export const addBlockchainPrefix =
    (address: string, blockchain: BlockchainNetwork) =>
        (address === '' ?
            '0x0000000000000000000000000000000000000000' :
            `${blockchainPrefixes[blockchain] ?? ''}${address}`)

export const removeBlockchainPrefix =
    (address: string, blockchain: BlockchainNetwork) => {
        if (!address) return address
        if (blockchain in blockchainPrefixes && address.startsWith(blockchainPrefixes[blockchain]!)) {
            return address.replace(blockchainPrefixes[blockchain]!, '').toLowerCase()
        }

        return address
    }

export const formatBlockchainAddress =
    (address: string) => `${address.slice(0, 4)}...${address.slice(-4)}`
